import { render, staticRenderFns } from "./CalendarEventFooterAdministerButtons.vue?vue&type=template&id=974cd888&scoped=true&"
import script from "./CalendarEventFooterAdministerButtons.vue?vue&type=script&lang=js&"
export * from "./CalendarEventFooterAdministerButtons.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventFooterAdministerButtons.vue?vue&type=style&index=0&id=974cd888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974cd888",
  null
  
)

export default component.exports